<div>
    <ng-container *ngTemplateOutlet="getTemplate()"></ng-container>
    <!--Boolean-Input-first-->
    <ng-template #varpropbooleaninputfirst id="var-prop-boolean-inputfirst">
        <input type="checkbox"
            *ngIf="selectedVariable.propertyObj[propertyName] && !selectedVariable.propertyObj[propertyName].dataBinding"
            class="app-checkbox app-widget-wrapper" [attr.name]="'wm-addvariable-property-'+propertyName"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
            (change)="selectedService.__onPropertyChange(propertyName)">
        <select
            *ngIf="selectedVariable.propertyObj[propertyName] && selectedVariable.propertyObj[propertyName].dataBinding"
            class="form-control app-select" [attr.name]="'wm-addvariable-property-'+propertyName"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
            (change)="selectedService.__onPropertyChange(propertyName)"
            [disabled]="selectedVariable.propertyObj[propertyName].disabled">
            <option *ngFor="let option of booleanFieldOptions| keyvalue" [value]="option.key">{{option.value}}</option>
        </select>
    </ng-template>

    <!--String-->
    <ng-template #varpropstring id="var-prop-string">
        <input class="form-control app-textbox app-widget-wrapper" *ngIf="showModelKey()"
            [attr.name]="'wm-addvariable-property-'+propertyName" type="text"
            placeholder="{{selectedVariable.propertyObj[propertyName].placeholder}}"
            (change)="baseVariableService.markUpdated()" [ngModelOptions]="{updateOn: 'change'}"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]">
    </ng-template>

    <!--Number-->
    <ng-template #varpropnumber id="var-prop-number">
        <input type="number" *ngIf="showModelKey()" class="form-control app-textbox app-widget-wrapper"
            [attr.name]="'wm-addvariable-property-'+propertyName"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
            (change)="selectedService.__onPropertyChange(propertyName)" [ngModelOptions]="{updateOn: 'change'}">
    </ng-template>

    <!--Boolean-->
    <ng-template #varpropboolean id="var-prop-boolean">
        <input type="checkbox" *ngIf="!selectedVariable.propertyObj[propertyName].dataBinding"
            class="app-checkbox app-widget-wrapper" [attr.name]="'wm-addvariable-property-'+propertyName"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
            (change)="selectedService.__onPropertyChange(propertyName)">
        <select *ngIf="selectedVariable.propertyObj[propertyName].dataBinding" class="form-control app-select"
            [attr.name]="'wm-addvariable-property-'+propertyName"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
            (change)="selectedService.__onPropertyChange(propertyName)"
            [disabled]="selectedVariable.propertyObj[propertyName].disabled">
            <option *ngFor="let option of booleanFieldOptions | keyvalue" [value]="option.key">{{option.value}}</option>
        </select>
    </ng-template>

    <!--Date-->
    <ng-template #varpropdate id="var-prop-date">
        <div class="date-container" *ngIf="showModelKey()">
            <!--TODO: <wm-date name="wm-addvariable-property-{{::propertyName}}"
                    datepattern="{{::getDisplayDateTimeFormat('date')}}"
                    type="uib-picker" on-change="markUpdated()"
                    scopedatavalue="wmvariables.selectedVariable.propertyObj[propertyName].modelObj[wmvariables.selectedVariable.propertyObj[propertyName].modelKey]">
            </wm-date> -->
            <input type="date" class="form-control app-textbox" [attr.name]="'wm-addvariable-property-'+propertyName"
                placeholder="Select date" [ngModelOptions]="$any({ updateOn: 'blur change' })"
                [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
                (change)="baseVariableService.markUpdated()" />
        </div>
    </ng-template>

    <!--Datetime-->
    <ng-template #varpropdatetime id="var-prop-datetime">
        <div class="datetime-container" *ngIf="showModelKey()">
            <!--TODO: <wm-datetime type="uib-picker"
                on-change="markUpdated()"
                name="wm-addvariable-property-{{::propertyName}}" datepattern="{{::getDisplayDateTimeFormat('datetime')}}" hourstep="1" minutestep="1"
                scopedatavalue="wmvariables.selectedVariable.propertyObj[propertyName].modelObj[wmvariables.selectedVariable.propertyObj[propertyName].modelKey]"
                outputformat="timestamp"></wm-datetime> -->
                <div class="app-datetime">
                    <input type="datetime-local" [attr.name]="'wm-addvariable-property-'+propertyName" class="form-control"
                    [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
                    (change)="baseVariableService.markUpdated()">
                </div>
        </div>
    </ng-template>

    <!--list-->
    <ng-template #varproplist id="var-prop-list">
        <select class="form-control app-select" *ngIf="showModelKey()" [attr.name]="'wm-addvariable-property-'+propertyName"
            [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
            (change)="selectedService?.__onPropertyChange && selectedService.__onPropertyChange(propertyName)"
            [disabled]="selectedVariable.propertyObj[propertyName].disabled">
            <option *ngFor="let option of selectedVariable.propertyObj[propertyName].options | keyvalue : skipSorting"
                [value]="option.key">{{locale[$any(option.value)] || option.value}}</option>
        </select>
    </ng-template>

    <!--event-->
    <ng-template #varpropevent id="var-prop-event">
        <div class="col-md-7 event-input-column">
            <wms-event-handler addBtnPosition="bottom" [eventName]="propertyName"
                [isVariableDialog]="true"
                [eventExpr]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
                (onNavigateAction)="navigateToScript($event)"
                (onChange)="selectedService?.__onPropertyChange(propertyName, $event)"></wms-event-handler>
        </div>
    </ng-template>

    <!--typeahead-->
    <ng-template #varproptypeahead id="var-prop-typeahead">
        <div *ngIf="showModelKey()" class="form-control wms-typeahead-variables">
            <!-- TO DO - check if the followinf prop is needed :  model-property-name="{{wmvariables.selectedVariable.propertyObj[propertyName].modelPropertyName || (wmvariables.selectedVariable.propertyObj[propertyName].groupBy ? '$key' : '$value')}}" -->
            <wms-typeahead name="wm-addvariable-property-{{propertyName}}" [typeaheadUid]="'addvariable-' + propertyName"
                [placeholder]="selectedVariable.propertyObj[propertyName].placeholder || (locale['LABEL_SEARCH'] + ' ' + (locale['LABEL_' + (propertyName.toUpperCase())] || propertyName))"
                [model]="getOptionModel()"
                [options]="selectedVariable.propertyObj[propertyName].options"
                (onClear)="clearModel(); selectedService?.__onPropertyChange && selectedService.__onPropertyChange(propertyName, {'$key': '', '$value': '' });"
                (onSelect)="handleModelChange($event)"
                [propertyName]="selectedVariable.propertyObj[propertyName].propertyName"
                [disable]="selectedVariable.propertyObj[propertyName].disabled"
                [editable]="editable"
                [groupBy]="selectedVariable.propertyObj[propertyName].groupBy" modelType="string" [modelKey]="isModelVarTypeProp() ? 'value': ''">
            </wms-typeahead>
        </div>
    </ng-template>

    <!--orderby-->
    <ng-template #varproporderby id="var-prop-order-by">
        <div class="col-md-5 app-property-orderby">
            <table class="wm-table">
                <tbody>
                    <tr *ngFor="let data of selectedVariable.propertyObj[propertyName].value"
                        [ngClass]="{'invalid-field': data.isInvalid}">
                        <td *ngIf="!data.isInvalid">
                            <button [attr.name]="'wm-orderby-field-'+data.key"
                                title="{{data.order === 'desc' ? locale['MESSAGE_DESCENDING_ORDER'] : locale['MESSAGE_ASCENDING_ORDER']}}"
                                class="btn btn-transparent orderby-action-btn"
                                (click)="alterOrderBy(selectedVariable.propertyObj[propertyName], data); baseVariableService.markUpdated();">
                                <i [ngClass]="{'wms-arrow-down': (data.order === 'desc'), 'wms-arrow-up': (data.order === 'asc')}"
                                    class="wm-icon wms"></i>
                            </button>
                        </td>
                        <td colspan="getColSpan(data)">
                            <label class="orderby-title">
                                <span
                                    title="{{data.isInvalid ? locale.MESSAGE_INVALID_FIELD : data.key}}">{{data.key}}</span>
                            </label>
                        </td>
                        <td class="orderby-actions">
                            <button [attr.name]="'wm-delete-orderby-field-'+data.key"
                                class="btn btn-transparent app-button orderby-action-btn"
                                title="{{locale.MESSAGE_PROPERTY_DELETE_FIELD}}"
                                (click)="deleteFieldOrderBy(selectedVariable.propertyObj[propertyName], data);baseVariableService.markUpdated();">
                                <i class="wm-icon wms wms-close"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="2">
                            <!-- TODO: [propertyName]="$key" -->
                            <wms-typeahead [attr.name]="'wm-property-typeahead-'+propertyName"
                                [placeholder]="locale.MESSAGE_SELECT_FIELD"
                                [options]="selectedVariable.propertyObj[propertyName].options"
                                (onSelect)="onModelChange.emit({propertyName, $event})"
                                [model]="selectedVariable.propertyObj[propertyName].typeaheadvalue">
                            </wms-typeahead>
                        </td>
                        <td>
                            <button [attr.name]="'wm-add-orderby-field'"
                                class="btn app-button btn-transparent orderby-action-btn"
                                title="{{locale.MESSAGE_PROPERTY_ADD_FIELD}}"
                                (click)="addOrderByField(selectedVariable.propertyObj[propertyName]); baseVariableService.markUpdated();">
                                <i class="wm-icon wms wms-plus"></i>
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </ng-template>

    <!--json-->
    <ng-template #varpropjson id="var-prop-json">
        <div class="btn-group wm-button-group"
            *ngIf="!(selectedVariable.isPrimitiveType && (selectedVariable.variableObject.type).toLowerCase() !== 'entry')">
            <button [attr.name]="'wm-addvariable-editjson-field-editor'" class="btn btn-default"
                (click)="refreshFieldEditor()" [ngClass]="{'active': baseVariableService.jsonEditorViewOption === 1}">{{locale['LABEL_FIELD_EDITOR']}}
            </button>
            <button [attr.name]="'wm-addvariable-editjson-text-editor'" class="btn btn-default"
                *ngIf="!(selectedVariable.isPrimitiveType && (selectedVariable.propertyObj.type.modelObj.type).toLowerCase() !== 'entry')"
                (click)="refreshTextEditor()" [ngClass]="{'active': baseVariableService.jsonEditorViewOption === 2}">{{locale['LABEL_TEXT_EDITOR']}}
            </button>
        </div>

        <!--dataset field-editor panel-->
        <div class="json-fields" *ngIf="baseVariableService.jsonEditorViewOption == 1">
            <!--panel for list type of variables(list of fields is displayed)-->
            <div *ngIf="selectedVariable.variableObject.isList">
              <!-- error panel if variable dataset is not array -->
              <div *ngIf="selectedVariable.variableObject['dataSet'].constructor.name !== 'Array'">
                  <wms-message [scopeDataset]='{"caption":"The variable data is not an array, please edit using Text Editor", "type": "error"}'></wms-message>
              </div>
              <div *ngIf="selectedVariable.variableObject['dataSet'].constructor.name === 'Array'">
                <!--buttons to add/remove fields-->
                <div class="tool-bar">
                  <button (click)="addField()" class="btn-transparent btn app-button"
                          title="{{locale.LABEL_ADD_FIELD}}">
                    <i class="app-icon wms wms-plus"></i>
                    <span class="btn-caption"></span></button>
                </div>
                <!-- ng-repeat assigned to div (not on ul above) to avoid triggering ng-repeat on variableObject.dataset-->
                <div class="data-values">
                  <ul *ngFor="let field of selectedVariable.variableObject['dataSet']; let index=index;">
                      <li *ngFor="let option of field | keyvalue; let $index=index; trackBy: trackByFn">
                          <div class="form-group app-composite-widget clearfix">
                              <label class="control-label app-label col-md-3" title="item{{index}}.{{option.key}}">
                                  item{{index}}.{{option.key}}
                              </label>
                              <input class="form-control app-textbox app-widget-wrapper"
                                     [attr.name]="'wm-addvariable-property-'+propertyName" type="text"
                                     [(ngModel)]="selectedVariable.variableObject['dataSet'][index][$any(option.key)]"
                                     (change)="onDataChange(selectedVariable.variableObject['dataSet'])"
                                     [ngModelOptions]="{updateOn: 'change'}">
                              <button (click)="removeField(index)" class="btn-transparent btn app-button" role="input"
                                      *ngIf="$index === 0 && selectedVariable.variableObject['dataSet'].length > 1"
                                      title="{{locale.LABEL_REMOVE_FIELD}}">
                                  <i class="app-icon wms wms-delete"></i> <span class="btn-caption"></span></button>
                          </div>
                      </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--panel for default type of variables(only one field is displayed)-->
            <ul *ngIf="!selectedVariable.variableObject.isList">
                <li *ngFor="let option of selectedVariable.variableObject['dataSet'] | keyvalue: skipSorting; let index=index; trackBy: trackByFn;">
                    <div class="form-group app-composite-widget clearfix"
                        *ngIf="selectedVariable.variableObject.type !== 'date'">
                        <label class="control-label app-label col-md-3" title="{{option.key}}">
                            {{option.key}}
                        </label>
                        <input class="form-control app-textbox app-widget-wrapper"
                            [attr.name]="'wm-addvariable-property-'+propertyName" type="text"
                            [(ngModel)]="selectedVariable.variableObject['dataSet'][$any(option.key)]"
                            [ngModelOptions]="{updateOn: 'change'}"
                            (change)="onDataChange(selectedVariable.variableObject['dataSet'])">
                    </div>
                    <div class="form-group app-composite-widget clearfix"
                        *ngIf="selectedVariable.variableObject.type === 'date'">
                        <label class="control-label app-label col-md-3" title="{{option.key}}">
                            {{option.key}}
                        </label>
                        <input class="form-control app-textbox app-widget-wrapper"
                            [attr.name]="'wm-addvariable-property-'+propertyName" type="text" placeholder="MM-dd-yyyy"
                            [(ngModel)]="selectedVariable.variableObject['dataSet'][$any(option.key)]"
                            [ngModelOptions]="{updateOn: 'change'}"
                            (change)="onDataChange(selectedVariable.variableObject['dataSet'])">
                    </div>
                </li>
            </ul>
        </div>
        <!-- TODO: delay-compile="100" -->
        <div class="code-editor" [style.display]="baseVariableService.jsonEditorViewOption === 2 ? 'block' : 'none'">
            <div class="wm-code-editor-container">
                <wms-editor [options]="baseVariableService.jsonTextEditor" (onChange)="updateEditorContent($event.options)" #codeEditor></wms-editor>
            </div>
        </div>
    </ng-template>

    <!--list-->
    <ng-template #varpropradioset id="var-prop-radioset">
        <div class="radio">
            <label *ngFor="let option of selectedVariable.propertyObj[propertyName].options | keyvalue: skipSorting">
                <input type="radio"
                    [attr.name]="'radio-'+propertyName"
                    value="{{option.key}}"
                    [(ngModel)]="selectedVariable.propertyObj[propertyName].modelObj[selectedVariable.propertyObj[propertyName].modelKey]"
                    (change)="selectedService.__onPropertyChange(propertyName, $event)"
                    [disabled]="selectedVariable.propertyObj[propertyName].disabled">
                {{locale[$any(option.value)] || option.value}}
            </label>
        </div>
    </ng-template>

</div>
